/*
 * Custom Cart bundle ATC interceptor (pilot: Hydrate + Treat Kit).
 * Loaded by snippets/custom-cart-bundle-atc.liquid, which provides the
 * #ccb-config JSON (bundle key/title, kit variant id, component variants
 * and their optional selling plan ids).
 *
 * Capture-phase submit hook (same proven pattern as eye-spray-upsell):
 * when the kit's product form submits, the kit SKU is NOT added — instead
 * each component is added as its own cart line, tagged with _bundle
 * properties so the cart template can group them and the discount
 * Function can price them.
 */
(function () {
  var configEl = document.getElementById('ccb-config');
  if (!configEl) return;

  var parsed;
  try {
    parsed = JSON.parse(configEl.textContent);
  } catch (err) {
    return;
  }
  // Config is an array (bundle + optional wand-toggle twin); accept a single
  // object too for backwards compatibility.
  var configsByVariant = {};
  (Array.isArray(parsed) ? parsed : [parsed]).forEach(function (config) {
    if (config && Number(config.kitVariantId) && Array.isArray(config.components) && config.components.length) {
      configsByVariant[Number(config.kitVariantId)] = config;
    }
  });
  if (!Object.keys(configsByVariant).length) return;

  var busy = false;

  function isSubscriptionSelected() {
    var checked = document.querySelector('input[name="purchaseOption"]:checked');
    return !!(checked && checked.value === 'subscription');
  }

  function buildLineItems(config, subscribed) {
    // Unique per add so two bundles in one cart group separately.
    var instance = config.bundleKey + '-' + Date.now().toString(36);
    return config.components.map(function (component) {
      var line = {
        id: Number(component.variantId),
        quantity: 1,
        properties: {
          _bundle: config.bundleKey,
          _bundle_instance: instance,
          _bundle_title: config.bundleTitle
        }
      };
      if (subscribed && component.sellingPlanId) {
        line.selling_plan = Number(component.sellingPlanId);
      }
      return line;
    });
  }

  function showError(form, message) {
    var wrapper = form.closest('product-form');
    var messageEl = wrapper && wrapper.querySelector('.product-form__error-message');
    if (messageEl) {
      messageEl.textContent = message;
      messageEl.closest('.product-form__error-message-wrapper').removeAttribute('hidden');
    }
  }

  function drawerSections() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (section) { return section.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function openCart(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && state && state.sections) {
      drawer.renderContents(state);
      // Dawn's renderContents only un-empties .drawer__inner; clear the rest
      // (matters when the page was server-rendered with an empty cart).
      drawer.classList.remove('is-empty');
      var itemsEl = drawer.querySelector('cart-drawer-items');
      if (itemsEl) itemsEl.classList.remove('is-empty');
    } else {
      window.location.href = '/cart';
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var idInput = form.querySelector('input[name="id"]');
    var config = idInput ? configsByVariant[Number(idInput.value)] : null;
    if (!config) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    busy = true;

    var submitBtn = form.querySelector('[name="add"]');
    if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: buildLineItems(config, isSubscriptionSelected()),
        sections: drawerSections(),
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (body) {
            throw new Error(body.description || body.message || 'Could not add the bundle to your cart.');
          });
        }
        return res.json();
      })
      .then(function (state) {
  openCart(state);
  return fetch('/cart.js');
})
.then(function (res) {
  if (!res.ok) {
    throw new Error('Failed to load cart');
  }
  return res.json();
})
.then(function (cart) {
  console.log('Updated cart:', cart);
})


      // .then(function (state) {
      //   openCart(state);
      // })
      .catch(function (err) {
        showError(form, err.message || 'Could not add the bundle to your cart. Please try again.');
      })
      .finally(function () {
        busy = false;
        if (submitBtn) submitBtn.removeAttribute('aria-disabled');
      });
  }, true); // capture: run before Dawn's product-form handler
})();
